import * as utils from "//mesmerizeindia.com/cdn/shop/t/196/assets/utils.js?v=121444215945374234871748841858";

/* Custom theme Function */

/**
 * Toggle logic to show/hide size information text.
 * @param {string} action - The action to perform. Use 'remove' to show the text, or any other value to hide it.
 */
                
export function toggleSizeInfoText(action) {
  let infoTextSelectors = document.querySelectorAll("[data-size-info-text]");
  if(infoTextSelectors.length>0){
    let heightOffset = Number(infoTextSelectors[0].dataset.heightOffset);
    if (!infoTextSelectors || infoTextSelectors.length === 0) return;
    infoTextSelectors.forEach(infoTextSelector => {
      if (action === 'remove') {
        infoTextSelector.classList.remove("hide");
        const element = document.querySelector(".variant-picker__option-values");
        let offsetTop = element.offsetTop;
        let targetScroll = offsetTop - heightOffset;
        window.scrollTo({
          top: targetScroll,
          behavior: 'smooth',
          block: 'nearest', 
          inline: 'start'
        });
      } else {
        infoTextSelector.classList.add("hide");
      }
    });
  }
}

export class VariantMetaFieldFeatures {
  constructor(product, variantId) {
    this.product = product;
    this.variantId = variantId;
    this._abortController = new AbortController(); 
    //Feature Cards
    this.variantCardMappingSelector = null;
    this.variantIdCardMapping = null;
    this.variantIdCardMappingJSON = null;
    //Pre order
    this.variantPreorderMappingSelector = null;
    this.variantIdPreorderMapping = null;
    this.variantIdPreorderMappingJSON = null;
    document.addEventListener("variant:preorder", this.setVariantToPreorder.bind(this));
  }


  /**
   * Retrieves the variant card mapping from the DOM using a selector
   * @param {string} selector - The ID of the element that contains the card mapping data.
   */
  getVariantCardMapping(selector) {
    if (this.product) {
       this.variantCardMappingSelector = document.getElementById(selector);
       if (this.variantCardMappingSelector) {
        this.variantIdCardMapping = this.variantCardMappingSelector.dataset.cardMapping;
        this.variantIdCardMappingJSON = this.variantIdCardMapping === '' ? undefined : JSON.parse(this.variantIdCardMapping);
      }
    }
  }

  /**
   * Retrieves the feature cards for the selected variant based on its ID.
   * @param {number | string} id - The ID of the variant to fetch feature cards for.
   * @returns {Array} An array of feature cards that match the provided variant ID.
   */
  getSelectedVariantFeatureCards(id) {
    if (this.variantIdCardMappingJSON && Array.isArray(this.variantIdCardMappingJSON)) {
      const selectedVariantFeatureCards = this.variantIdCardMappingJSON.filter(card => card.variant_id === Number(id));
      return selectedVariantFeatureCards;
    } else {
      return [];
    }
  }

  /**
   * Generates and appends variant feature cards dynamically to the rootSelector.
   * @param {number} id - The variant ID to filter the feature cards by.
   */
  createVariantFeatureCards(id) {
    const selectedVariantCards = this.getSelectedVariantFeatureCards(id);
    const rootSelector = document.querySelectorAll(".product-info__variant-offer-list");

    rootSelector.forEach(root => {
      root.innerHTML = '';
    });

    // If rootSelector is empty or no cards are selected, exit the function early
    if (rootSelector.length === 0 || selectedVariantCards.length === 0) return;

    const rootSelectorDataAttr = rootSelector[0].dataset;
    const { cardBg, iconPosition, textAlignment, cardText } = rootSelectorDataAttr;

    const offerListContainer = document.createElement('div');
    offerListContainer.classList.add('product-info__offer-list');

    // Create individual offer cards and append them inside the offer list container
    selectedVariantCards[0].feature_cards.forEach(card => {
      const offerCard = document.createElement('div');
      const alignmentClass = textAlignment === "center" ? 'offer--center' : '';
      offerCard.classList.add('offer');
      if (alignmentClass) {
        offerCard.classList.add(alignmentClass);
      }

      const iconPositionClass = iconPosition === 'aligned' ? "text-with-icon" : "text-without-icon";

      offerCard.style.backgroundColor = cardBg;
      offerCard.style.color = cardText;
      offerCard.innerHTML = `
        <div class="${iconPositionClass}">
          ${card.icon_svg}
          <span class="bold text-sm">${card.heading}</span>
        </div>
        ${card.description ? `
          <div class="prose text-sm">
            ${card.description}
          </div>
        ` : ''}
      `;

      offerListContainer.appendChild(offerCard);
    });

    rootSelector[0].appendChild(offerListContainer);
  }


  /**
 * Retrieves the preorder mapping data from the DOM element specified by the selector.
 * It assigns the parsed JSON data to the class properties for further usage.
 * @param {string} selector - The ID of the DOM element containing the preorder mapping data.
 */
  getVariantPreorderMapping(selector) {
     if (this.product) {
       this.variantPreorderMappingSelector = document.getElementById(selector);
       if(this.variantPreorderMappingSelector){
       this.variantIdPreOrderMapping = this.variantPreorderMappingSelector.dataset.preorderMapping;
       this.variantIdPreOrderMappingJSON = JSON.parse(this.variantIdPreOrderMapping);
      }
     }
  }

  /**
 * Retrieves the selected preorder variant based on the provided variant ID.
 * It searches for the variant in the parsed JSON mapping.
 * @param {string|number} id - The variant ID to search for in the preorder mapping.
 * @returns {Array} - Returns an array containing the matched variant object, or an empty array if no match is found.
 */
  getSelectedPreorderVariant(id) {
  if (Array.isArray(this.variantIdPreOrderMappingJSON)) {
    return this.variantIdPreOrderMappingJSON.filter(map => map.variant_id === Number(id)) || [];
  }
  return [];
}
  
  /**
 * Handles the preorder process for a product variant by updating the visibility of the preorder container 
 * and modifying the "Add to Cart" buttons based on the variant's ship date.
 * @param {Event} event - The event triggered when the preorder process is initiated.
 */
  setVariantToPreorder(event) {
    const { variantId } = event.detail;
    const variant = this.getSelectedPreorderVariant(variantId)[0];
    let currentDate = new Date();
    const shipDateObj = variant ? new Date(variant['variant_preorder_shipdate']) : currentDate;
    currentDate.setHours(0, 0, 0, 0);
    const hasPreorder = shipDateObj > currentDate ? true : false;
    
    // Update preorder container visibility and message using innerHTML
    document.querySelectorAll(".product-variant__Ship-date").forEach(container => {
      container.style.display = hasPreorder ? "block" : "none";
      container.innerHTML = hasPreorder ? 
        `<p class="bold mb-10">Will ship by ${utils.formatDateToDDMMYYYY(shipDateObj)}</p>` : "";
    });
  
    // Update Add to Cart buttons
    const buttons = [
      ...document.querySelectorAll('.product-info button[type="submit"]'),
      ...document.querySelectorAll('.product-quick-add button[type="submit"]')
    ];
  
    buttons.forEach(button => {
      if (hasPreorder) {
        const buttonText = button.getAttribute("is") === "custom-button" ? button.firstElementChild : button;
        if (buttonText) buttonText.textContent = window.themeVariables.strings.preOrderButton; // Safely update text content
      }
    });
  }

}
